export default "__VITE_ASSET__Cmb$IsUH__"